import { FunctionComponent as F } from "react";
import LinkIcon from '@mui/icons-material/Link';
import Link from "@mui/material/Link";
import TextTooltip from "../Tooltip/TextTooltip";
import { TooltipPlacement } from "../../../core/types/component";



interface IProps
{
  url?: string;
  tooltipText?: string;
  tooltipPlacement?: TooltipPlacement;
  iconHeight?: string
}

const LinkOpt: F<IProps> = (props: IProps) =>
{
  return(props.url ?
    <TextTooltip tooltipPlacement={props.tooltipPlacement} lines={[props.tooltipText || props.url]}>
      <Link
        variant='body2'
        underline='hover'
        target='_blank'
        rel='noreferrer'
        href={props.url}
        style={{ cursor: 'pointer', color: 'gray' }} >
        <LinkIcon sx={{ height: props.iconHeight, fontSize: 18 }}/>
      </Link>
    </TextTooltip> :
    <></>);
};

export default LinkOpt;
